import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { CardPackGroup } from './CardPackGroup';
import { BuyPacks_cardPackGroup } from './__generated__/index.graphql';

const Root = styled.div`
  padding: var(--double-unit) 0;
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);

  @media ${tabletAndAbove} {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
`;

type Props = { cardPackGroups: BuyPacks_cardPackGroup[] };
export const BuyPacks = ({ cardPackGroups }: Props) => {
  return (
    <Root>
      {cardPackGroups.map(cardPackGroup => {
        return (
          <CardPackGroup key={cardPackGroup.id} cardPackGroup={cardPackGroup} />
        );
      })}
    </Root>
  );
};

BuyPacks.fragments = {
  cardPackGroup: gql`
    fragment BuyPacks_cardPackGroup on CardPackGroup {
      id
      ...CardPackGroup_cardPackGroup
    }
    ${CardPackGroup.fragments.cardPackGroup}
  ` as TypedDocumentNode<BuyPacks_cardPackGroup>,
};
